import type { AgentType } from '@ardoq/api-types';
import { TourAuthorOverlay } from '@ardoq/product-tours';

export const Toolbox = ({ agentType }: { agentType: AgentType | undefined }) =>
  agentType === 'product_tour' ? <TourAuthorOverlay /> : null;
